import axios from 'axios'

const apiBaseCommunity = {
    'production': 'https://parenttown.com/api/',
    'staging': 'https://staging.parenttown.com/api/',
    'development': 'https://staging.parenttown.com/api/'
}

const apiBaseTap = {
    'production': 'https://api.theasianparent.com/api/v1/',
    'staging': 'https://dev-api.theasianparent.com/api/v1/',
    'development': 'https://dev-api.theasianparent.com/api/v1/'
}

const apiOtpCommunity = {
    'production': 'https://otp.parenttown.com/',
    'staging': 'https://staging-otp.parenttown.com/',
    'development': 'https://staging-otp.parenttown.com/',
    'uat': 'https://beta-otp.parenttown.com/'
}

const CONFIG = {
    env: 'staging', //production|staging|development
    timeout: 0
}

const getCommunityAPIBase = (env = CONFIG.env, version = 'v2') => {
    const url = apiBaseCommunity[['production', 'staging', 'development'].indexOf(env) !== -1 ? env : 'staging'];
    return `${url}${version}/`
}

const getTapAPIBase = (env = 'staging') => {
    return apiBaseTap[['production', 'staging', 'development'].indexOf(env) !== -1 ? env : 'staging']
}

const getCommunityOtpApiBase = (env = 'staging') => {
    return apiOtpCommunity[['production', 'staging', 'development'].indexOf(env) !== -1 ? env : 'staging']
}

export const fetchPollDataCall = (config = CONFIG, pollId) => {
    const params = {
        questionId: pollId
    };

    const instance = axios.create();
    if (config.timeout) {
        instance.defaults.timeout = config.timeout;
    }
    return instance.get(`${getCommunityAPIBase(config.env)}poll`, {params})
        .then((xhrResponse) => {
            return xhrResponse
        })
        .catch((error) => {
            return error
        });
}

export const fetchCovidLandingDataCall = (config = CONFIG, country, tapWeb = false) => {
    if (!country) {
        return "country manditory";
    }

    const params = {};

    if (tapWeb) {
        params.tapWeb = tapWeb
    }

    const instance = axios.create();
    if (config.timeout) {
        instance.defaults.timeout = config.timeout;
    }
    return instance.get(`${getCommunityAPIBase(config.env)}covid/landing/${country}`, {params})
        .then((xhrResponse) => {
            return xhrResponse
        })
        .catch((error) => {
            return error
        });
}

export const fetchArticleDataCall = (config = CONFIG, country, route, isMobile = 0, locale = '') => {
    if (!country || !route) {
        return "country & route manditory";
    }

    const params = {
        isMobile: isMobile
    };

    if (locale) {
        params.locale = locale
    }

    const instance = axios.create();
    if (config.timeout) {
        instance.defaults.timeout = config.timeout;
    }
    return instance.get(`${getTapAPIBase(config.env)}${country}/posts/${route.charAt(0) == '/' ? route.substr(1) : route}`, {params})
        .then((xhrResponse) => {
            return xhrResponse
        })
        .catch((error) => {
            return error
        });
}

export const gtmSendHttp = (gaID, event, category, action = "", label = "", value = 1, cid = 0) => {
    if (!gaID || !event || !category) {
        return "gaID & event & category manditory";
    }

    const params = {
        v: 1,                   // Version.
        tid: gaID,              // Tracking ID / Property ID.
        cid: cid,               // Anonymous Client ID.
        t: event,               // Event hit type
        ec: category,           // Event Category. Required.
        ea: action,             // Event Action. Required.
        el: label,              // Event label.
        ev: value               // Event value.
    }

    const instance = axios.create();
    return instance.get(`https://www.google-analytics.com/collect`, {params})
        .then((xhrResponse) => {
            return xhrResponse
        })
        .catch((error) => {
            return error
        });
}

export const communityValidEmail = async (config = CONFIG, user, params = {}) => {
    if (!user.country) {
        return {
            error: true, message: 'country mandatory in validateEmail function'
        }
    }

    const headers = config.headers || {};

    headers[`country`] = user.country;
    headers[`deviceType`] = user.isMobile ? 'mobile' : 'desktop';
    headers[`lang`] = user.userLocale || user.locale;
    headers[`sourceApp`] = 'tap';

    const instance = axios.create();

    //instance.defaults.withCredentials = true;
    if (config.timeout) {
        instance.defaults.timeout = config.timeout;
    }

    return instance.post(`${getCommunityAPIBase(config.env, 'v3')}email/check`, params, {headers})
        .then((xhrResponse) => {
            return xhrResponse;
        })
        .catch((error) => {
            return error
        });
}

export const communityValidateMobile = async (config = CONFIG, user, params = {}) => {

    if (!user.country) {
        return {
            error: true, message: 'country mandatory in validateMobile function'
        }
    }

    const headers = config.headers || {};

    headers[`country`] = user.country;
    headers[`deviceType`] = user.isMobile ? 'mobile' : 'desktop';
    headers[`lang`] = user.userLocale || user.locale;
    headers[`sourceApp`] = 'tap';

    const instance = axios.create();

    //instance.defaults.withCredentials = true;
    if (config.timeout) {
        instance.defaults.timeout = config.timeout;
    }

    return instance.post(`${getCommunityAPIBase(config.env, 'v4')}phone/check`, params, {headers})
        .then((xhrResponse) => {
            return xhrResponse;
        })
        .catch((error) => {
            return error
        });
}


export const loginCommunityUser = async (config = CONFIG, user, params = {}) => {

    if (!user.country) {
        return {
            error: true, message: 'country mandatory in loginCommunityUser function'
        }
    }

    const headers = config.headers || {};

    headers[`country`] = user.country;
    headers[`deviceType`] = user.isMobile ? 'mobile' : 'desktop';
    headers[`lang`] = user.userLocale || user.locale;
    headers[`sourceApp`] = 'tap';

    const instance = axios.create();

    //instance.defaults.withCredentials = true;
    if (config.timeout) {
        instance.defaults.timeout = config.timeout;
    }

    return instance.post(`${getCommunityAPIBase(config.env, 'v3')}login`, params, {headers})
        .then((xhrResponse) => {
            return xhrResponse;
        })
        .catch((error) => {
            return error
        });
}

export const generateEmailOTP = async (config = CONFIG, user, params = {}) => {

    if (!user.country) {
        return {
            error: true, message: 'country mandatory in generateEmailOTP function'
        }
    }

    const headers = config.headers || {};

    headers[`country`] = user.country;
    headers[`deviceType`] = user.isMobile ? 'mobile' : 'desktop';
    headers[`lang`] = user.userLocale || user.locale;
    headers[`sourceApp`] = 'tap';

    const instance = axios.create();

    //instance.defaults.withCredentials = true;
    if (config.timeout) {
        instance.defaults.timeout = config.timeout;
    }

    return instance.post(`${getCommunityOtpApiBase(config.env)}otp/generate/email`, params, {headers})
        .then((xhrResponse) => {
            return xhrResponse;
        })
        .catch((error) => {
            return error
        });
}

export const generateMobileOTP = async (config = CONFIG, user, params = {}) => {

    if (!user.country) {
        return {
            error: true, message: 'country mandatory in generateMobileOTP function'
        }
    }

    const headers = config.headers || {};

    headers[`country`] = user.country;
    headers[`deviceType`] = user.isMobile ? 'mobile' : 'desktop';
    headers[`lang`] = user.userLocale || user.locale;
    headers[`sourceApp`] = 'tap';

    const instance = axios.create();

    //instance.defaults.withCredentials = true;
    if (config.timeout) {
        instance.defaults.timeout = config.timeout;
    }

    return instance.post(`${getCommunityOtpApiBase(config.env)}otp/generate/phone`, params, {headers})
        .then((xhrResponse) => {
            return xhrResponse
        })
        .catch((error) => {
            return error
        });
}

export const forgotPasswordEmail = async (config = CONFIG, user, params) => {

    if (!user.country) {
        return {
            error: true, message: 'country mandatory in forgotPasswordEmail function'
        }
    }

    const headers = config.headers || {};

    headers[`country`] = user.country;
    headers[`deviceType`] = user.isMobile ? 'mobile' : 'desktop';
    headers[`lang`] = user.userLocale || user.locale;
    headers[`sourceApp`] = 'tap';

    const instance = axios.create();


    //instance.defaults.withCredentials = true;
    if (config.timeout) {
        instance.defaults.timeout = config.timeout;
    }

    return instance.post(`${getCommunityAPIBase(config.env, 'v2')}email/forgot`, params, {headers})
        .then((xhrResponse) => {
            return xhrResponse;
        })
        .catch((error) => {
            return error
        });
}

export const forgotPasswordMobile = async (config = CONFIG, user, params) => {

    if (!user.country) {
        return {
            error: true, message: 'country mandatory in forgotPasswordMobile function'
        }
    }

    const headers = config.headers || {};

    headers[`country`] = user.country;
    headers[`deviceType`] = user.isMobile ? 'mobile' : 'desktop';
    headers[`lang`] = user.userLocale || user.locale;
    headers[`sourceApp`] = 'tap';

    const instance = axios.create();


    //instance.defaults.withCredentials = true;
    if (config.timeout) {
        instance.defaults.timeout = config.timeout;
    }

    return instance.post(`${getCommunityAPIBase(config.env, 'v2')}phone/forgot`, params, {headers})
        .then((xhrResponse) => {
            return xhrResponse;
        })
        .catch((error) => {
            return error
        });
}


export const verifyEmailOTP = async (config = CONFIG, user, params = {}) => {

    if (!user.country) {
        return {
            error: true, message: 'country mandatory in verifyEmailOTP function'
        }
    }

    const headers = config.headers || {};

    headers[`country`] = user.country;
    headers[`deviceType`] = user.isMobile ? 'mobile' : 'desktop';
    headers[`lang`] = user.userLocale || user.locale;
    headers[`sourceApp`] = 'tap';

    const instance = axios.create();

    //instance.defaults.withCredentials = true;
    if (config.timeout) {
        instance.defaults.timeout = config.timeout;
    }

    return instance.post(`${getCommunityOtpApiBase(config.env)}otp/verify/email`, params, {headers})
        .then((xhrResponse) => {
            return xhrResponse;
        })
        .catch((error) => {
            return error
        });
}

export const verifyMobileOTP = async (config = CONFIG, user, params = {}) => {

    if (!user.country) {
        return {
            error: true, message: 'country mandatory in verifyMobileOTP function'
        }
    }

    const headers = config.headers || {};

    headers[`country`] = user.country;
    headers[`deviceType`] = user.isMobile ? 'mobile' : 'desktop';
    headers[`lang`] = user.userLocale || user.locale;
    headers[`sourceApp`] = 'tap';

    const instance = axios.create();

    //instance.defaults.withCredentials = true;
    if (config.timeout) {
        instance.defaults.timeout = config.timeout;
    }

    return instance.post(`${getCommunityOtpApiBase(config.env)}otp/verify/phone`, params, {headers})
        .then((xhrResponse) => {
            return xhrResponse;
        })
        .catch((error) => {
            return error
        });
}

export const setLoggedInCommunityUser = async (config = CONFIG, params = {}) => {

    let apiVersion = 'v2';
    const headers = config.headers || {};
    headers[`sourceApp`] = 'tap';

    if (params.lang) {
        headers['lang'] = params.lang;
        delete params.lang;
    }

    if (params.country) {
        headers['country'] = params.country;
        delete params.country;
    }

    if (params.device_type) {
        headers['deviceType'] = params.device_type;
    }

    if (params.apiVersion) {
        apiVersion = params.apiVersion;
        delete params.apiVersion;
    }

    const instance = axios.create();
    // instance.defaults.withCredentials = true;
    if (config.timeout) {
        instance.defaults.timeout = config.timeout;
    }
    return instance.post(`${getCommunityAPIBase(config.env, apiVersion)}login`, params, {headers})
        .then((xhrResponse) => {
            return xhrResponse;
        })
        .catch((error) => {
            return error
        });
};

export * from './authentication-service.js';

// Comment to update
// Comment to update